import { createReducer, on } from '@ngrx/store';

import { AnalyticsSessionActions } from './analytics-session.actions';
import { AnalyticsSessionState, initialAnalyticsSessionState } from './analytics-session.model';

export const analyticsSessionReducer = createReducer<AnalyticsSessionState>(
  initialAnalyticsSessionState,

  on(AnalyticsSessionActions.rumSessionDetected, (state, { sessionId }): AnalyticsSessionState => ({
    ...state,
    rumSessionId: sessionId,
  })),

  on(AnalyticsSessionActions.fullStorySessionDetected, (state, { url }): AnalyticsSessionState => ({
    ...state,
    fullStorySessionUrl: url,
  }))
);
